/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import "./DeviceFirmwareUpdate.css";
import {
  Table,
  Pagination,
  Button,
  Input,
  InputGroup,
  Modal,
  Form,
  SelectPicker,
  CheckTreePicker,
  Uploader,
  Textarea,
  DateRangePicker,
} from "rsuite";
import SearchIcon from "@rsuite/icons/Search";
import PlusIcon from "@rsuite/icons/Plus";
import EditIcon from "@rsuite/icons/Edit";
import Header from "../../commonComponents/Header";
import {
  ErrorNotify,
  SuccessNotify,
} from "../../commonComponents/ToastMessage";

import useAuth from "../../hooks/useAuth";
import { ToastContainer } from "react-toastify";
import ShowLoader from "../../commonComponents/ShowLoader";
import moment from "moment";
import * as XLSX from "xlsx";
import StatsCard from "../DashBoard/StatsCard";
import {
  DownloadFiles,
  FormDataPostApi,
  GetApi,
} from "../../services/ApiService";
import { FormatKey } from "../../Utils";

const { Column, HeaderCell, Cell } = Table;

const DeviceFirmwareUpdate = () => {
  const { auth } = useAuth();
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [sortColumn, setSortColumn] = useState();
  const [sortType, setSortType] = useState();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [formData, setFormData] = useState({});
  const [showForm, setShowForm] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [showLoader, setShowLoader] = useState(false);

  const [tableData, setTableData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [uploadingList, setUploadingList] = useState([]);
  const [selectedDateRange, setSelectedDateRange] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [dropDownEquipmentCategoryData, setDropDownEquipmentCategoryData] =
    useState([]);
  const [dropDownEquipmentData, setDropDownEquipmentData] = useState([]);
  const [dropDownFirmwareVersions, setDropDownFirmwareVersions] = useState([]);
  const [dropDownOtaStatus, setDropDownOtaStatus] = useState([]);
  const [
    dropDownEquipmentCategoryWiseData,
    setDropDownEquipmentCategoryWiseData,
  ] = useState([]);

  const [selectedEquipmentCategory, setSelectedEquipmentCategory] =
    useState("");
  const [selectedEquipment, setSelectedEquipment] = useState("");
  const [selectedFirmwareVersion, setSelectedFirmwareVersion] = useState("");
  const [selectedOtaStatus, setSelectedOtaStatus] = useState("");
  const [showExportOptions, setShowExportOptions] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState("");
  const [selectedEndDate, setSelectedEndDate] = useState("");
  const [exportSelectedDate, setExportSelectedDate] = useState([]);
  const empKpiData = {
    totalEquipments: "",
    onLatestVersion: "",
    pendingUpdates: "",
    successfulUpdates: "",
    failedUpdates: "",
  };
  const [kpiData, setKpiData] = useState(empKpiData);

  useEffect(() => {
    GetCategoryList();
  }, []);

  useEffect(() => {
    const hasDateRange = selectedDateRange?.length > 1;

    let startDate = "";
    let endDate = "";

    if (hasDateRange) {
      startDate = moment(selectedDateRange[0]).format("YYYY-MM-DD");
      endDate = moment(selectedDateRange[1]).format("YYYY-MM-DD");
    }

    if (hasDateRange) {
      setSelectedStartDate(startDate);
      setSelectedEndDate(endDate);
      GetKpiData(startDate, endDate);
      GetFirmwareData(
        searchKeyword,
        selectedEquipment,
        selectedEquipmentCategory,
        selectedFirmwareVersion,
        selectedOtaStatus,
        startDate,
        endDate,
        1,
      );
    } else {
      setSelectedStartDate("");
      setSelectedEndDate("");
      GetKpiData("", "");
      GetFirmwareData(
        searchKeyword,
        selectedEquipment,
        selectedEquipmentCategory,
        selectedFirmwareVersion,
        selectedOtaStatus,
        "",
        "",
        1,
      );
    }
  }, [selectedDateRange]);

  const handleSortColumn = (sortColumn, sortType) => {
    setSortColumn(sortColumn);
    setSortType(sortType);
  };

  // Form Validation errors
  const validate = (data) => {
    const errors = {};
    const { selectedCategory, file, version, releaseNotes } = data;

    if (!selectedCategory)
      errors.selectedCategory = "Please select at least one equipment.";

    const fileName = file?.length > 0 ? file[0]?.name || "" : "";

    if (!file) {
      errors.file = "Please upload a firmware file.";
    } else if (!fileName.endsWith(".bin")) {
      errors.file = "Only .bin firmware files are allowed.";
    }
    if (!version) {
      errors.version = "Please fill the version";
    }
    if (!releaseNotes) {
      errors.releaseNotes = "Please fill the release notes";
    }
    return errors;
  };

  const clearError = (field) => {
    setFormErrors((prev) => ({
      ...prev,
      [field]: undefined,
    }));
  };

  const handleChange = (name, value) => {
    const updatedData = { ...formData, [name]: value };
    setFormData(updatedData);

    let errors = {};

    setFormErrors((prev) => ({
      ...prev,
      ...errors,
      [name]: errors[name] || undefined,
    }));
  };

  const handleAddNew = () => {
    setFormData({});
    setUploadingList([]);
    setFormErrors({});
    setShowForm(true);
  };

  const handleSubmit = () => {
    const errors = validate(formData);
    setFormErrors(errors);

    if (Object.keys(errors).length !== 0) {
      ErrorNotify("Please fix the highlighted errors before submitting.");
      return;
    }
    console.log("Form Data to submit:", formData);

    setShowForm(false);

    setShowLoader(true);
    uploadFirmware({
      userId: auth.user.id,
      equipmentIds: [],
      deviceIds: formData.selectedDevices,
      version: formData?.version,
      releaseNotes: formData?.releaseNotes ? formData?.releaseNotes : "",
      file: formData.file[0].blobFile,
    });
  };

  const handleExportCsv = () => {
    const wb = XLSX.utils.book_new();

    let Data = tableData?.map((e) => {
      return {
        "Equipment Name": e.equipment_name,
        Category: e.equipment_category,
        "Equipment Type": e.equipment_type,
        "Previous Firmware": e.previous_firmware,
        "Firmware Version": e.firmware_version,
        "OTA Status": e.ota_status,
        "Created At": e.created_at,
        "Completion Date": e.completion_date,
        "Updated By": e.updated_by,
      };
    });

    const ws1 = XLSX.utils.json_to_sheet(Data);

    XLSX.utils.book_append_sheet(wb, ws1, "Firmware Data");

    XLSX.writeFile(wb, "firmware_export.csv", { bookType: "csv" });

    setShowExportOptions(false);
    SuccessNotify("Firmware data exported as CSV.");
  };

  const handleExportExcel = () => {
    const wb = XLSX.utils.book_new();

    let Data = tableData?.map((e) => {
      return {
        "Equipment Name": e.equipment_name,
        Category: e.equipment_category,
        "Equipment Type": e.equipment_type,
        "Previous Firmware": e.previous_firmware,
        "Firmware Version": e.firmware_version,
        "OTA Status": e.ota_status,
        "Created At": e.created_at,
        "Completion Date": e.completion_date,
        "Updated By": e.updated_by,
      };
    });

    const ws1 = XLSX.utils.json_to_sheet(Data);

    XLSX.utils.book_append_sheet(wb, ws1, "Firmware Data");

    XLSX.writeFile(wb, "firmware_export.xlsx", { bookType: "xlsx" });

    setShowExportOptions(false);
    SuccessNotify("Firmware data exported as Excel.");
  };

  const handleExport = () => {
    setExportSelectedDate([]);
    setShowExportOptions(true);
  };

  const handleCloseExportOptions = () => {
    setShowExportOptions(false);
    setExportSelectedDate([]);
  };

  const getNestedValue = (obj, path) => {
    return path.split(".").reduce((acc, part) => acc?.[part], obj);
  };

  const filteredData = () => {
    const sortedData = [...tableData];
    if (sortColumn && sortType) {
      sortedData.sort((a, b) => {
        let x = getNestedValue(a, sortColumn);
        let y = getNestedValue(b, sortColumn);

        // handle null values
        x = x ?? "";
        y = y ?? "";

        // date columns
        if (sortColumn === "created_at" || sortColumn === "updated_at") {
          x = x ? new Date(...x.split("/").reverse()) : new Date(0);
          y = y ? new Date(...y.split("/").reverse()) : new Date(0);
        } else if (!isNaN(x) && !isNaN(y) && x !== "" && y !== "") {
          x = Number(x);
          y = Number(y);
        }

        // string sorting
        if (typeof x === "string") x = x.toLowerCase();
        if (typeof y === "string") y = y.toLowerCase();

        if (x > y) return sortType === "asc" ? 1 : -1;
        if (x < y) return sortType === "asc" ? -1 : 1;

        return 0;
      });
    }
    return sortedData;
  };

  const GetFirmwareData = (
    search,
    equip,
    cat,
    version,
    status,
    fromDate,
    toDate,
    page,
  ) => {
    GetApi(
      `utho/ota-records?search=${search}&equipment_id=${equip}&category=${cat}&firmware_version=${version}&ota_status=${status}&from_date=${fromDate}&to_date=${toDate}&page=${page}&limit=${limit}`,
      auth.accessToken,
    )
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          setTableData(res.data.records);
          setTotalCount(res.data.total_records);
          const versionsFilter = res.data.filter_options.firmware_versions.map(
            (item) => ({ label: FormatKey(item), value: item }),
          );
          const otaStatusFilter = res.data.filter_options.ota_statuses.map(
            (item) => ({ label: FormatKey(item), value: item }),
          );
          setDropDownFirmwareVersions(versionsFilter);
          setDropDownOtaStatus(otaStatusFilter);
          setLoading(false);
          setShowLoader(false);
        } else {
          ErrorNotify(res.message);
          setTableData([]);
          setTotalCount(0);
          setLoading(false);
          setShowLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
        ErrorNotify(error);
        setTableData([]);
        setTotalCount(0);
        setLoading(false);
        setShowLoader(false);
      });
  };

  const GetCategoryList = () => {
    GetApi("utho/equipment-category-wise", auth.accessToken)
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          const onboardedCategories = res.data.categories.filter(
            (item) => item?.device_count > 0,
          );

          const onboardedEquipments = onboardedCategories.flatMap((eqflat) =>
            eqflat.equipment.filter((eq) => eq?.devices?.length > 0),
          );

          const categoryData = onboardedCategories.map((item) => ({
            label: item.category_name,
            value: item.category_name,
            code: item.category_code,
          }));

          const equipmentData = onboardedEquipments.map((item) => ({
            label: item.equipment,
            value: item.equipment,
            category: item.equipment_category_txt,
          }));

          const equipmentCategoryWiseData = onboardedCategories.map((item) => ({
            label: item.category_name,
            value: item.category_name,
            children: item.equipment
              .filter((eq) => eq?.devices?.length > 0)
              .map((eq) => ({
                label: eq.equipment,
                value: eq.devices[0]?.id,
                device_id: eq.devices[0]?.id,
                imei_number: eq.devices[0]?.imei_number,
              })),
          }));

          setDropDownEquipmentCategoryData(categoryData);
          setDropDownEquipmentData(equipmentData);
          setDropDownEquipmentCategoryWiseData(equipmentCategoryWiseData);
        } else {
          ErrorNotify(res.message);
          setDropDownEquipmentCategoryData([]);
          setDropDownEquipmentData([]);
          setDropDownEquipmentCategoryWiseData([]);
        }
      })
      .catch((error) => {
        console.log(error);
        ErrorNotify(error);
        setDropDownEquipmentCategoryData([]);
        setDropDownEquipmentData([]);
        setDropDownEquipmentCategoryWiseData([]);
      });
  };

  const GetKpiData = (fromDate, toDate) => {
    GetApi(
      `utho/ota-dashboard-kpis?from_date=${fromDate}&to_date=${toDate}`,
      auth.accessToken,
    )
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          setKpiData({
            totalEquipments: res.data?.total_equipment,
            onLatestVersion: res.data?.equipment_on_latest_version,
            pendingUpdates: res.data?.pending_updates,
            successfulUpdates: res.data?.successful_updates,
            failedUpdates: res.data?.failed_updates,
          });
          setLoading(false);
        } else {
          ErrorNotify(res.message);
          setLoading(false);
          setKpiData(empKpiData);
        }
      })
      .catch((error) => {
        console.log(error);
        ErrorNotify(error);
        setLoading(false);
        setKpiData(empKpiData);
      });
  };

  const uploadFirmware = async ({
    userId,
    equipmentIds,
    deviceIds,
    version,
    releaseNotes,
    file,
  }) => {
    const bodyRequestFormData = new FormData();

    bodyRequestFormData.append("user_id", userId);
    bodyRequestFormData.append("equipment_id", equipmentIds);
    bodyRequestFormData.append("device_id", deviceIds);
    bodyRequestFormData.append("version", version);
    bodyRequestFormData.append("release_notes", releaseNotes);
    bodyRequestFormData.append("file", file);

    FormDataPostApi(`utho/upload`, auth.accessToken, bodyRequestFormData)
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          SuccessNotify("Firmware File uploaded successlly");
          setFormData({});
          setUploadingList([]);
          GetFirmwareData("", "", "", "", "", "", "", 1);
        } else {
          ErrorNotify(res.message);
          setShowLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
        ErrorNotify(error);
        setShowLoader(false);
      });
  };

  const DownloadFile = async (format) => {
    setShowLoader(true);
    const hasDateRange = exportSelectedDate?.length > 1;

    let startDate = "";
    let endDate = "";

    if (hasDateRange) {
      startDate = moment(exportSelectedDate[0]).format("YYYY-MM-DD");
      endDate = moment(exportSelectedDate[1]).format("YYYY-MM-DD");
    }
    const response = await DownloadFiles(
      `utho/reports/export?report_type=status&from_date=${startDate}&to_date=${endDate}&format=${format}`,
      auth.accessToken,
    );

    const blob = await response.blob();

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `Firmware Data.${format}`;
    link.click();

    URL.revokeObjectURL(url);
    setShowExportOptions(false);
    setShowLoader(false);
  };

  return (
    <div className="h-100 w-100 d-flex flex-column bg-light">
      <div className="h-8 w-100 pr-10 d-flex flex-row">
        <Header
          pageName="Device Firmware Update"
          backBtn={true}
          isDateRange={true}
          setSelectedDate={setSelectedDateRange}
          selectedDate={selectedDateRange}
        />
        <ToastContainer />
      </div>
      {showLoader ? <ShowLoader></ShowLoader> : null}
      <div className="h-92 pr-10 d-flex flex-column overflow-auto pb-10">
        {/* Row 1: Top Stats */}
        <div className="cardsView">
          <StatsCard title="Total Equipments" value={kpiData.totalEquipments} />
          <StatsCard
            title="On Latest Version"
            value={kpiData.onLatestVersion}
          />
          <StatsCard title="Pending Updates" value={kpiData.pendingUpdates} />
          <StatsCard
            title="Successful Updates"
            value={kpiData.successfulUpdates}
          />
          <StatsCard title="Failed Updates" value={kpiData.failedUpdates} />
        </div>

        {/* Row 3: Project Comparison & Cost Optimization */}
        <div className="h-100 project-row">
          <div className="h-100 bg-white p-10 rounded shadow-sm d-flex flex-column flex-grow-1">
            <div className="top-bar">
              {/* Filters Section */}
              <div className="filter-section">
                <div className="filter-item">
                  <InputGroup inside>
                    <Input
                      placeholder="Search..."
                      value={searchKeyword}
                      onChange={(e) => {
                        setPage(1);
                        setLoading(true);

                        if (e.trim() === "") {
                          setSearchKeyword("");
                          GetFirmwareData(
                            "",
                            selectedEquipment,
                            selectedEquipmentCategory,
                            selectedFirmwareVersion,
                            selectedOtaStatus,
                            selectedStartDate,
                            selectedEndDate,
                            1,
                          );
                        } else {
                          setSearchKeyword(e);
                          GetFirmwareData(
                            e,
                            selectedEquipment,
                            selectedEquipmentCategory,
                            selectedFirmwareVersion,
                            selectedOtaStatus,
                            selectedStartDate,
                            selectedEndDate,
                            1,
                          );
                        }
                      }}
                    />
                    <InputGroup.Addon>
                      <SearchIcon />
                    </InputGroup.Addon>
                  </InputGroup>
                </div>

                <div className="filter-item">
                  <SelectPicker
                    data={dropDownEquipmentCategoryData}
                    // searchable={false}
                    className="w-100"
                    placeholder="Filter by Category"
                    value={selectedEquipmentCategory}
                    onChange={(value) => {
                      setPage(1);
                      setLoading(true);
                      if (value) {
                        setSelectedEquipmentCategory(value);
                        GetFirmwareData(
                          searchKeyword,
                          selectedEquipment,
                          value,
                          selectedFirmwareVersion,
                          selectedOtaStatus,
                          selectedStartDate,
                          selectedEndDate,
                          1,
                        );
                      } else {
                        setSelectedEquipmentCategory("");
                        GetFirmwareData(
                          searchKeyword,
                          selectedEquipment,
                          "",
                          selectedFirmwareVersion,
                          selectedOtaStatus,
                          selectedStartDate,
                          selectedEndDate,
                          1,
                        );
                      }
                    }}
                  />
                </div>
                <div className="filter-item">
                  <SelectPicker
                    data={dropDownEquipmentData}
                    // searchable={false}
                    className="w-100"
                    placeholder="Filter by Equipment"
                    value={selectedEquipment}
                    onChange={(value) => {
                      setPage(1);
                      setLoading(true);
                      if (value) {
                        setSelectedEquipment(value);
                        GetFirmwareData(
                          searchKeyword,
                          value,
                          selectedEquipmentCategory,
                          selectedFirmwareVersion,
                          selectedOtaStatus,
                          selectedStartDate,
                          selectedEndDate,
                          1,
                        );
                      } else {
                        setSelectedEquipment("");
                        GetFirmwareData(
                          searchKeyword,
                          "",
                          selectedEquipmentCategory,
                          selectedFirmwareVersion,
                          selectedOtaStatus,
                          selectedStartDate,
                          selectedEndDate,
                          1,
                        );
                      }
                    }}
                  />
                </div>
                <div className="filter-item">
                  <SelectPicker
                    data={dropDownFirmwareVersions}
                    // searchable={false}
                    className="w-100"
                    placeholder="Filter by Firmware Version"
                    value={selectedFirmwareVersion}
                    onChange={(value) => {
                      setPage(1);
                      setLoading(true);
                      if (value) {
                        setSelectedFirmwareVersion(value);
                        GetFirmwareData(
                          searchKeyword,
                          selectedEquipment,
                          selectedEquipmentCategory,
                          value,
                          selectedOtaStatus,
                          selectedStartDate,
                          selectedEndDate,
                          1,
                        );
                      } else {
                        setSelectedFirmwareVersion("");
                        GetFirmwareData(
                          searchKeyword,
                          selectedEquipment,
                          selectedEquipmentCategory,
                          "",
                          selectedOtaStatus,
                          selectedStartDate,
                          selectedEndDate,
                          1,
                        );
                      }
                    }}
                  />
                </div>
                <div className="filter-item">
                  <SelectPicker
                    data={dropDownOtaStatus}
                    searchable={false}
                    className="w-100"
                    placeholder="Filter by OTA Status"
                    value={selectedOtaStatus}
                    onChange={(value) => {
                      setPage(1);
                      setLoading(true);
                      if (value) {
                        setSelectedOtaStatus(value);
                        GetFirmwareData(
                          searchKeyword,
                          selectedEquipment,
                          selectedEquipmentCategory,
                          selectedFirmwareVersion,
                          value,
                          selectedStartDate,
                          selectedEndDate,
                          1,
                        );
                      } else {
                        setSelectedOtaStatus("");
                        GetFirmwareData(
                          searchKeyword,
                          selectedEquipment,
                          selectedEquipmentCategory,
                          selectedFirmwareVersion,
                          "",
                          selectedStartDate,
                          selectedEndDate,
                          1,
                        );
                      }
                    }}
                  />
                </div>
              </div>

              {/* Button Section */}
              <div className="button-section">
                <Button
                  appearance="primary"
                  startIcon={<PlusIcon />}
                  onClick={handleAddNew}
                >
                  Add New
                </Button>
                <Button appearance="primary" onClick={handleExport}>
                  Export
                </Button>
              </div>
            </div>

            <div className="pt-10" style={{ flex: 1, minHeight: 0 }}>
              <Table
                key={`${sortColumn}-${sortType}`}
                fillHeight={true}
                data={filteredData()}
                sortColumn={sortColumn}
                sortType={sortType}
                onSortColumn={handleSortColumn}
                loading={loading}
                bordered
                wordWrap="break-word"
              >
                <Column align="center" sortable width={80}>
                  <HeaderCell>ID</HeaderCell>
                  <Cell dataKey="file_id" />
                </Column>
                <Column align="center" sortable flexGrow={1} minWidth={150}>
                  <HeaderCell>Equipment Name</HeaderCell>
                  <Cell dataKey="equipment_id" />
                </Column>
                <Column flexGrow={1} minWidth={150} align="center" sortable>
                  <HeaderCell>Category</HeaderCell>
                  <Cell dataKey="category" />
                </Column>
                <Column flexGrow={1} minWidth={150} align="center" sortable>
                  <HeaderCell>Equipment Type</HeaderCell>
                  <Cell dataKey="equipment_type" />
                </Column>
                <Column flexGrow={1} minWidth={150} align="center" sortable>
                  <HeaderCell>Previous Firmware</HeaderCell>
                  <Cell dataKey="current_version" />
                </Column>
                <Column flexGrow={1} minWidth={150} align="center" sortable>
                  <HeaderCell>Firmware Version</HeaderCell>
                  <Cell dataKey="latest_version" />
                </Column>
                <Column flexGrow={1} minWidth={150} align="center" sortable>
                  <HeaderCell>Release Notes</HeaderCell>
                  <Cell dataKey="release_notes">
                    {(rowData) => (
                      <div>
                        {rowData.release_notes ? rowData.release_notes : "-"}
                      </div>
                    )}
                  </Cell>
                </Column>
                <Column flexGrow={1} minWidth={150} align="center" sortable>
                  <HeaderCell>OTA Status</HeaderCell>
                  <Cell dataKey="ota_status" style={{ padding: 0 }}>
                    {(rowData) => (
                      <div style={{ lineHeight: "46px", paddingLeft: "10px" }}>
                        <span
                          className={
                            rowData.ota_status === "Success"
                              ? "activeStatus"
                              : rowData.ota_status === "Downloaded"
                                ? "suspendedStatus"
                                : "expiredStatus"
                          }
                        >
                          {rowData.ota_status.toUpperCase()}
                        </span>
                      </div>
                    )}
                  </Cell>
                </Column>
                <Column
                  flexGrow={1}
                  minWidth={160}
                  sortable
                  verticalAlign="middle"
                >
                  <HeaderCell>Created At</HeaderCell>
                  <Cell dataKey="deployment_date">
                    {(rowData) => (
                      <div>
                        {rowData.deployment_date
                          ? moment(rowData.deployment_date).format(
                              "DD-MM-YYYY HH:mm:ss",
                            )
                          : "-"}
                      </div>
                    )}
                  </Cell>
                </Column>
                <Column flexGrow={1} minWidth={160} align="center" sortable>
                  <HeaderCell>Completion At</HeaderCell>
                  <Cell dataKey="completion_date">
                    {(rowData) => (
                      <div>
                        {rowData.completion_date
                          ? moment(rowData.completion_date).format(
                              "DD-MM-YYYY HH:mm:ss",
                            )
                          : "-"}
                      </div>
                    )}
                  </Cell>
                </Column>

                <Column flexGrow={1} minWidth={120} align="center" sortable>
                  <HeaderCell>Updated By</HeaderCell>
                  <Cell dataKey="updated_by" />
                </Column>
                {/* <Column
                  flexGrow={1}
                  minWidth={120}
                  align="center"
                  verticalAlign="middle"
                >
                  <HeaderCell>Action</HeaderCell>
                  <Cell dataKey="id" style={{ padding: 0 }}>
                    {(rowData) => (
                      <Stack spacing={2} align={"center"}>
                        <IconButton
                          size="sm"
                          appearance="subtle"
                          icon={
                            <EditIcon size={20} style={{ color: "#3f51b5" }} />
                          }
                          onClick={() => {
                            // handleEdit(rowData)
                          }}
                        />
                      </Stack>
                    )}
                  </Cell>
                </Column> */}
              </Table>
            </div>

            <div style={{ padding: 10, paddingBottom: 0 }}>
              <Pagination
                prev
                next
                first={!isMobile}
                last={!isMobile}
                ellipsis={!isMobile}
                boundaryLinks
                maxButtons={isMobile ? 3 : 5}
                layout={["total", "-", "pager"]}
                total={totalCount}
                limit={limit}
                activePage={page}
                onChangePage={(e) => {
                  setPage(e);
                  setLoading(true);
                  GetFirmwareData(
                    searchKeyword,
                    selectedEquipment,
                    selectedEquipmentCategory,
                    selectedFirmwareVersion,
                    selectedOtaStatus,
                    selectedStartDate,
                    selectedEndDate,
                    e,
                  );
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Firmware Table POPUP*/}
      <Modal
        open={showForm}
        onClose={() => {
          setShowForm(false);
          setUploadingList([]);
        }}
        size="sm"
      >
        <Modal.Header>
          <Modal.Title>Add New Firmware</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form fluid onChange={setFormData} formValue={formData}>
            {/* Operators */}
            <Form.Group>
              <Form.ControlLabel>Device Select *</Form.ControlLabel>
              <Form.Control
                searchable={true}
                name="selectedCategory"
                accepter={CheckTreePicker}
                data={dropDownEquipmentCategoryWiseData}
                style={{ width: "100%" }}
                placeholder="Select Equipments"
                errorPlacement="static"
                errorMessage={formErrors.selectedCategory}
                onChange={() => {
                  clearError("selectedCategory");
                }}
                onCascadeChange={(value) => {
                  setFormData((prev) => ({
                    ...prev,
                    selectedDevices: value,
                  }));
                }}
              />
            </Form.Group>

            {/* File Name */}
            <Form.Group>
              <Form.ControlLabel>File Upload *</Form.ControlLabel>
              <Form.Control
                accepter={Uploader}
                autoUpload={false}
                listType="picture-text"
                // action="https://cemindia.iot-platform.in/api/utho/upload"
                // headers={{
                //   Authorization: `Bearer ${auth.accessToken}`,
                // }}
                // method="POST"
                // data={{ user_id: auth?.user?.id }}
                multiple={false}
                fileList={uploadingList}
                disabled={uploadingList.length >= 1}
                name="file"
                accept=".bin"
                onChange={(files) => {
                  clearError("file");
                  if (files.length <= 1) {
                    setUploadingList(files);
                  }
                }}
                onSuccess={(response) => {
                  console.log("onSuccess:", response);
                  if (
                    response.statusCode === 200 ||
                    response.statusCode === 201
                  ) {
                    setFormData((prev) => ({
                      ...prev,
                      uthoFile: {
                        name: response.data.original_filename,
                        url: response.data.download_link,
                      },
                    }));
                    clearError("file");
                    SuccessNotify("File uploaded successfully.");
                  } else {
                    ErrorNotify("File upload failed. Please try again.");
                  }
                }}
                onError={(response) => {
                  console.log("onError:", response);
                  ErrorNotify(
                    "File upload failed. " +
                      (response?.response?.message || "Please try again."),
                  );
                }}
                shouldQueueUpdate={(fileList) => {
                  return fileList.slice(0, 1);
                }}
                shouldUpload={(file) => {
                  return file.name.toLowerCase().endsWith(".bin");
                }}
                errorPlacement="static"
                errorMessage={formErrors.file}
              >
                <Button disabled={uploadingList.length >= 1}>
                  {uploadingList.length ? "File Uploaded" : "Select File"}
                </Button>
              </Form.Control>
            </Form.Group>
            <Form.Group>
              <Form.ControlLabel>Version *</Form.ControlLabel>
              <Form.Control
                name="version"
                placeholder="Enter Version"
                errorPlacement="static"
                errorMessage={formErrors.version}
                onChange={(value) => handleChange("version", value)}
              />
            </Form.Group>
            <Form.Group>
              <Form.ControlLabel>Release Notes *</Form.ControlLabel>
              <Form.Control
                name="releaseNotes"
                placeholder="Enter Release Notes"
                accepter={Textarea}
                rows={5}
                errorPlacement="static"
                errorMessage={formErrors.releaseNotes}
                onChange={(value) => handleChange("releaseNotes", value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <button
            className="CancelBtn"
            onClick={() => {
              setShowForm(false);
              setUploadingList([]);
            }}
          >
            Cancel
          </button>
          <Button onClick={handleSubmit} appearance="primary">
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        open={showExportOptions}
        onClose={handleCloseExportOptions}
        size="xs"
      >
        <Modal.Header>
          <Modal.Title>Export Table Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Select a date range to export firmware records.</p>
          <div style={{ display: "flex", gap: 12, marginBottom: 12 }}>
            <DateRangePicker
              size="md"
              placeholder="Select Date Range"
              block
              showOneCalendar
              value={(() => {
                const val =
                  exportSelectedDate?.length > 0
                    ? [
                        new Date(exportSelectedDate[0]),
                        new Date(exportSelectedDate[1]),
                      ]
                    : null;
                return val;
              })()}
              shouldDisableDate={(date) => {
                const now = new Date();

                // Set today to 00:00:00
                const today = new Date(
                  now.getFullYear(),
                  now.getMonth(),
                  now.getDate(),
                );

                return date.getDay() > today.getDay();
              }}
              ranges={[]}
              onChange={(value) => {
                if (value?.length > 0) {
                  const startDate = new Date(value[0]);
                  startDate.setHours(0, 0, 0, 0);

                  const endDate = new Date(value[1]);
                  endDate.setHours(23, 59, 59, 999);

                  const startIosStringFormat = startDate.toISOString();
                  const endIosStringFormat = endDate.toISOString();
                  setExportSelectedDate([
                    startIosStringFormat,
                    endIosStringFormat,
                  ]);
                } else {
                  setExportSelectedDate([]);
                }
              }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            appearance="primary"
            onClick={() => {
              DownloadFile("csv");
            }}
          >
            CSV
          </Button>
          <Button
            appearance="primary"
            onClick={() => {
              DownloadFile("xlsx");
            }}
          >
            Excel
          </Button>
          <Button
            appearance="primary"
            onClick={() => {
              DownloadFile("pdf");
            }}
          >
            PDF
          </Button>
          <button className="CancelBtn" onClick={handleCloseExportOptions}>
            Cancel
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DeviceFirmwareUpdate;
